import { useState } from "react";
import { Button, Box } from "@mui/material";
import LoginDialog from "./LoginDialog";
import LoginIcon from "@mui/icons-material/Login";

const LoginButton = (props) => {
  const [open, setOpen] = useState(false);

  return (
    <div>
      <Box display="flex">
        <Button
          data-testid="loginButton"
          sx={{ marginLeft: "auto" }}
          variant="contained"
          onClick={() => setOpen(true)}
        >
          <LoginIcon></LoginIcon>
        </Button>
      </Box>

      <LoginDialog open={open} setOpen={setOpen}></LoginDialog>
    </div>
  );
};

export default LoginButton;
